<template>
  <div class="bread">
    <div>
      <strong>
        <font-awesome-icon
          v-if="icon"
          :icon="icon"
          size="2x"
        />
        {{ strong }}
      </strong>
    </div>
    <div>
      <el-breadcrumb
        separator="/"
        class="el-bread"
      >
        <el-breadcrumb-item
          v-for="item in $route.matched"
          :key="item.name"
          :to="item.path"
        >
          <font-awesome-icon
            v-if="item.meta.icon"
            :icon="item.meta.icon"
          /> {{ obterBreadcrum(item) }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>

// import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { mapGetters } from 'pinia';
import { loginStore } from 'operass-spa/src/app/login/vuex/index';

export default {
  name: 'CcBread',
  // components: { FontAwesomeIcon },
  data() {
    return {
      strong: '',
      icon: '',
    };
  },
  watch: {
    /* eslint-disable no-unused-vars */
    $route(to, from) {
      this.loadTitle(to.matched);
    },
  },
  created() {
    this.loadTitle(this.$route.matched);
  },
  methods: {
    /* mapeamento acoes vuex */
    ...mapGetters(loginStore, ['currentClient']),

    obterBreadcrum(item) {
      if (this.currentClient() !== null) { return item.meta.breadcrum.replace('{Cliente}', this.currentClient()); }
      return item.meta.breadcrum;
    },

    loadTitle(matched) {
      if (matched.length) {
        const matc = matched[matched.length > 1 ? matched.length - 1 : matched.length - 1];
        this.strong = this.obterBreadcrum(matc);
        this.icon = matc.meta.icon;
      }
    },
  },
};
</script>

<style scoped lang='less'>
    .bread{
      z-index: 0;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div{
        display: flex;
        align-content: center;
      }
      .el-bread {
          // display: inline-block;
          float: right;
          text-align: right;
          line-height: 26px;
      }
    }
</style>
